// extracted by mini-css-extract-plugin
module.exports = {"button":"Counter__button___3EJX6","points":"Counter__points___1nFVS"};